import { featureItems } from '../../../mocks/entertainment';
import SectionHead from './SectionHead';

export default function Features() {
  return (
    <section id="features" className="relative scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <SectionHead
          eyebrow="深扒专题 · 观点观察"
          title="不只看热闹，也聊聊门道"
          desc="榜单之外，我们把镜头拉远。从一场发布会聊到粉丝文化变迁，观点仅供参考，欢迎一起探讨。"
          align="center"
        />
        <p className="mx-auto mt-2 max-w-2xl text-center text-xs text-foreground-400">
          深扒仅为个人观点与公开信息整理，不代表任何官方立场。
        </p>

        <div className="mt-10 flex flex-col gap-5">
          {featureItems.map((f) => (
            <article
              key={f.title}
              className="group flex flex-col overflow-hidden rounded-xl bg-background-100 ring-1 ring-background-200/70 transition-colors hover:ring-accent-300 md:flex-row"
            >
              <div className="relative md:w-[300px] md:shrink-0 lg:w-[380px]">
                <img
                  src={f.img}
                  alt={`深扒专题配图，${f.title}`}
                  title={f.title}
                  className="aspect-[16/9] w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.03] md:aspect-auto md:h-full"
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                  {f.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col justify-center p-5 md:p-7">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-edit-2-line text-accent-600" aria-hidden="true"></i>
                    专题编辑部
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    约 {f.readMin}
                  </span>
                </div>
                <h3 className="mt-3 text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                  {f.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600 md:text-base">{f.excerpt}</p>
                <div className="mt-5 flex items-center gap-4">
                  <a
                    href="#subscribe"
                    className="inline-flex items-center whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
                  >
                    阅读全文
                    <i className="ri-arrow-right-line ml-1.5" aria-hidden="true"></i>
                  </a>
                  <span className="text-xs text-foreground-400">长文将在订阅后推送，或下周加更上线</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}